(() => {
    "use strict";

    var mobileNavToggle = document.querySelector(".nav-toggle");

    /**
     * Mobile Nav functionality
     */
    const mobileNavItems = document.querySelectorAll(".nav__menu .nav__item");
    mobileNavItems.forEach(item => {
        item.addEventListener("click", event => {
            if (! item.classList.contains("with-dropdown") || item.classList.contains("nav__group__link") || window.getComputedStyle(mobileNavToggle).display !== "flex") {
                return true; 
            } 

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            item.classList.toggle("active");
          
            if (item.classList.contains("active")) { 
                mobileNavItems.forEach(mobileNavItem => {
                    if (! mobileNavItem.classList.contains("active")) {
                        mobileNavItem.style.overflow = "hidden";
                        mobileNavItem.style.maxHeight = 0;
                    }
                })
            } else {
                mobileNavItems.forEach(mobileNavItem => {
                    mobileNavItem.style.overflow = "auto";
                    mobileNavItem.style.maxHeight = "100vh";
                })
            }
        })
    });

    // Book Button
    const mobileBookingNav = document.querySelector('.mobile-booking-nav')
    const navMenuToggle = document.getElementById('nav-menu-toggle');

    document.querySelector("#book-toggle").addEventListener("click", () => {
        if (mobileBookingNav.classList.contains('active')) {
            mobileBookingNav.classList.remove('active')
        }
        else {
            mobileBookingNav.classList.add('active')
        }

        if (navMenuToggle.classList.contains('nav-toggle--active')) {
            document.getElementById('nav-menu-toggle').click();
        }
    });

    // Links cant bubble up as it will cause the menu to switch without sending them to the link
    document.querySelectorAll(".nav__group__link, .nav__group__cell").forEach(item => {
        item.addEventListener("click", event => {
            event.stopPropagation();
        });
    });

    document.getElementById('nav-menu-toggle') && document.getElementById('nav-menu-toggle').addEventListener('click', function () {
        this.classList.toggle('nav-toggle--active');
        
        if (this.classList.contains("nav-toggle--active")) {
            document.getElementById('nav').classList.add('nav--active');
        }
        else {
            document.getElementById('nav').classList.remove('nav--active');
            mobileNavItems.forEach(mobileNavItem => {
                mobileNavItem.classList.remove("active");
                mobileNavItem.style.overflow = "unset";
                mobileNavItem.style.maxHeight = "unset";
            })
        }

        mobileBookingNav.classList.remove('active')
    });

    // When the visitor scrolls 60px from top, resize the navbar padding
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
        let headerNav = document.querySelector(".header__nav");

        if (window.innerWidth > 559) {
            // Set defaults if they switch screen widths
            headerNav.style.position = "relative";
            headerNav.style.top = 0;
            headerNav.style.marginTop = 0;

            if (document.body.scrollTop > 60 || document.documentElement.scrollTop > 60) {
                document.querySelectorAll('.nav__item').forEach(item => item.classList.add('nav__item--active'));
                document.querySelector('.header').classList.add('header--active');
            } else {
                document.querySelectorAll('.nav__item').forEach(item => item.classList.remove('nav__item--active'));
                document.querySelector('.header').classList.remove('header--active');
            }
        } else {
            if (document.body.scrollTop > 60 || document.documentElement.scrollTop > 60) {
                headerNav.style.position = "sticky";
                headerNav.style.top = 0;
                headerNav.style.marginTop = "-6.5rem";
            }
            else {
                headerNav.style.position = "relative";
                headerNav.style.top = 0;
                headerNav.style.marginTop = 0;
            }
        }
    }

    document.querySelector('[data-aos]') && AOS.init({
        offset: 0,
        duration: 1200,
        disable: 'mobile',
        once: true
    });

    document.querySelector('.testimonials') && new Splide('.testimonials', {
        // type: 'carousel',
        type: 'loop',
        perPage: 3,
        perMove: 1,
        pagination: false,
        breakpoints: {
            1410: {
                perPage: 2,
            },
            780: {
                perPage: 1,
            }
        }
    }).mount();

    document.getElementById('reviews-slider') && new Splide('#reviews-slider', {
        type: 'carousel',
        perPage: 3,
        perMove: 1,
        pagination: false,
        gap: '1.75rem',
        breakpoints: {
            1028: {
                perPage: 2,
            },
            600: {
                perPage: 1,
            }
        }
    }).mount();

    document.getElementById('gallery-slider') && new Splide('#gallery-slider', {
        type: 'Carousel',
        perPage: 3,
        perMove: 1,
        pagination: false,
        gap: '2.19rem',
        arrows: false,
    }).mount();

    document.querySelector('[data-fancybox]') && Fancybox.bind('[data-fancybox]', {
    });


    // FAQs across the website
    if (document.querySelector('.faq')) {
        const faqs = document.querySelectorAll('.faq')
        for (let i = 0; i < faqs.length; i++) {
            faqs[i].addEventListener('click', function (e) {
                this.classList.toggle('faq--active')
            })
        }
    }

    // // Alert close
    // document.querySelector(".close-alert").addEventListener("click", () => {
    //         document.querySelector('.homepage-alert').style.display = "none";
    // });

    // // Wait a few seconds before showing the alert
    // setTimeout(function(){
    //     document.querySelector('.alert').style.display = "block";
    //     },3000);

        // Alert close
    document.querySelector(".close-alert").addEventListener("click", () => {
            document.querySelector('.homepage-alert').style.visibility = "hidden";
    });

    // Wait a few seconds before showing the alert
    setTimeout(function(){
        document.querySelector('.homepage-alert').style.visibility = "visible";
        document.querySelector('.alert').style.opacity = 1;
        },2000);

})();